import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  languageChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  changeLanguage(language: string) {
    this.languageChanged.emit(language);
  }
}